module.exports = __webpack_public_path__ + "media/error-mobile.6960ec5d.png";